export function deprecate(fn) {
  return fn
}

export function equal() {}

export function ok() {}

export function unreachable() {}
